import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView        from "./TemplateListView";
import CCTVCamAdminDetailsView from "./CCTVCamAdminDetailsView";
import CCTVCamAdminNewView     from "./CCTVCamAdminNewView";


const CCTVCamAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "CCTVCamAdmin.pageState";
  const defaultPageState = {
    searchField: "Code",
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'code',
      name: t("I18N_Code"),
      sortable: true,
      sortField: 'code',
      grow: 2,
      cell: null
    },
    {
      name: t("I18N_Name"),
      selector: row => row.name,
      grow: 1,
      wrap: true,
      sortable: true,
      sortField: 'name',
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
/*
    {
      name: t("I18N_Display_name"),
      selector: row => row.displayName,
      grow: 1.5,
      wrap: true,
      sortable: true,
      sortField: 'displayName',
    },
    {
      name: t("I18N_Asset_code"),
      selector: row => row.assetCode,
      grow: 1,
      wrap: true,
      sortable: true,
      sortField: 'assetCode',
    },
*/
    {
      name: t("I18N_Location"),
      selector: row => row.location,
      wrap: true,
      sortable: true,
      sortField: 'location',
    },
    {
      name: t("I18N_Coverage_loc"),
      selector: row => row.coverageLoc,
      wrap: true,
      sortable: true,
      sortField: 'coverageLoc',
    },
    {
      name: t("I18N_Lift_code"),
      selector: row => row.liftCode,
      wrap: true,
      sortable: true,
      sortField: 'liftCode',
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----

  const searchFieldOptions = [
    { key: "CODE",  value: "CODE" },
    { key: "DESCRIPTION", value: "DESCRIPTION" }
  ];


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API} apiObjName={'cctv-cams-admin'}
                                                  listPageTitle={t("I18N_CCTVCam_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_CCTV_cam")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_CCTVCam_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_CCTV_cam")}
                                                  deleteObjNameField={"code"}
                                                  tableColumns={tableColumns}
                                                  searchFieldOptions={searchFieldOptions}
                                                  deletePermission={'CCTVAdminDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <CCTVCamAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <CCTVCamAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default CCTVCamAdmin;
